import PropTypes from 'prop-types';
// @mui
import { CircularProgress, Stack, TableCell, TableRow, Typography } from '@mui/material';

// ----------------------------------------------------------------------

TableLoadingRow.propTypes = {
  colSpan: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  emptyLabel: PropTypes.string,
};

export default function TableLoadingRow({
  colSpan,
  isLoading = false,
  loadingLabel = 'Fetching records…',
  emptyLabel = 'No records yet',
}) {
  return (
    <TableRow>
      <TableCell align="center" colSpan={colSpan} sx={{ py: 6, border: 'none' }}>
        <Stack alignItems="center" spacing={1.5}>
          {isLoading ? (
            <>
              <CircularProgress size={28} thickness={4} />
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {loadingLabel}
              </Typography>
            </>
          ) : (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {emptyLabel}
            </Typography>
          )}
        </Stack>
      </TableCell>
    </TableRow>
  );
}
